import { Component, OnInit, ViewChild } from '@angular/core'
import { STColumn, STComponent } from '@delon/abc/st'
import { SFSchema } from '@delon/form'
import { ModalHelper, _HttpClient } from '@delon/theme'

@Component({
  selector: 'app-support-operation',
  templateUrl: './operation.component.html',
})
export class SupportOperationComponent implements OnInit {
  searchSchema: SFSchema = {
    properties: {},
  }
  @ViewChild('st') private readonly st!: STComponent
  columns: STColumn[] = []

  constructor(
    private http: _HttpClient,
    private modal: ModalHelper,
  ) {}

  ngOnInit(): void {}

  add(): void {}
}
